import {useAppDispatch} from "../../Redux/store";
import { callAPI, overallActions } from "../services/slice";
import overallAPI from "../services/api";
import {getTitleFromSubdomain, setFaviconAndTitle, setThemeColors} from "../../Util/Util";
import useGetBkey from "../hooks/useGetBkey";
import { useTranslation } from "react-i18next";

const useGetBranch = () => {
    const dispatch = useAppDispatch();
    const { getKey } = useGetBkey();
    const { t } = useTranslation();

    const fallbackTitle = getTitleFromSubdomain();

    const onGetBranch = () => {
        const host = window.location.host;
        const bKey = getKey();

        let time = "";
        const timeMatch = window.location.hash.match(/time=([^&]*)/);

        if (timeMatch) {
            time = timeMatch[1];
        } else {
            setFaviconAndTitle("", fallbackTitle);

            dispatch(overallActions.setBranchError(t("qr_expire")));
            dispatch(overallActions.setBranchLoading(false));
            return;
        }

        const action = async () => {
            return await overallAPI.getBranchByWebsite(host, bKey, time);
        };

        const success = (branchData: any) => {

            // ❌ API success nhưng không có branch
            if (!branchData) {
                setFaviconAndTitle("", fallbackTitle);

                dispatch(overallActions.setBranchError(t("qr_expire")));
                dispatch(overallActions.setBranchLoading(false));
                return;
            }

            dispatch(overallActions.setBranch(branchData));

            const prefix = process.env.REACT_APP_API_URL || "";

            const logoUrl = branchData.logo_top
                ? branchData.logo_top.startsWith("http")
                    ? branchData.logo_top
                    : `${prefix}/${encodeURI(branchData.logo_top)}`
                : undefined;

            setFaviconAndTitle(
                logoUrl,
                branchData.name || fallbackTitle
            );

            setThemeColors(
                branchData.ticket_bg_color,
                branchData.primary_text_color,
                branchData.ticket_hover_color,
                branchData.table_border_color
            );
        };

        dispatch(
            callAPI(
                action,
                success,
                undefined,
                () => {
                    // ❌ API trả status = error
                    setFaviconAndTitle("", fallbackTitle);

                    dispatch(overallActions.setBranchError(t("qr_expire")));
                    dispatch(overallActions.setBranchLoading(false));
                }
            )
        );
    };

    return { onGetBranch };
};

export default useGetBranch;
